// extracted by mini-css-extract-plugin
module.exports = {"resources":"resources-module--resources--3qJvB","intro":"resources-module--intro--2MelP","files":"resources-module--files--1xs7q"};